import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  amount: number | string
}

const TransferredBalance = ({ amount }: Props) => (
  <Box flexDirection="row" justifyContent="spaceBetween">
    <Text.Normal color="grey000White">
      {i18n.t('time_off.available_tooltip.transferred_balance')}
    </Text.Normal>
    <Text.Normal color="grey000White">{amount}</Text.Normal>
  </Box>
)

export default TransferredBalance
